'use client'

import { useCallback, useMemo } from 'react'
import { useAppStore } from 'lib/hooks/useAppStore'
import { useCustomer } from 'lib/customer'
import { getUrlFromLink } from 'lib/helpers'
import { useRouter } from 'next/router'
import { urlForImage } from 'lib/sanity.image'

import { Button } from './Button'
import Image from 'next/image'
import { Newsletter } from './Newsletter'

export const Footer = ({ menus, logo }) => {
  const { setAccountModal } = useAppStore()
  const { data: customer } = useCustomer()
  const router = useRouter()

  const logoUrl = useMemo(() => {
    return logo
      ? urlForImage(logo).width(100).auto('format').url()
      : '/chnge_logo.png'
  }, [logo])

  const handleAccountClick = useCallback(() => {
    if (customer) {
      return router.push('/account', undefined, { scroll: false })
    }

    setAccountModal(true)
  }, [customer, router, setAccountModal])

  return (
    <div className="w-full p-20 pb-28 pt-[100px]">
      <div className="w-full rounded-8 bg-white p-20 pt-50 text-11 text-darkGray shadow-md">
        <div className="flex w-full flex-wrap justify-between">
          <div className="grid w-full max-w-[600px] grid-cols-1 md:flex-1 md:grid-cols-3">
            {menus.map((menu) => {
              return (
                <div key={menu._key} className="pb-20 md:pb-0">
                  <div className="pb-12 pl-8 md:pb-16">{menu.title}</div>
                  <ul className="flex flex-wrap gap-[5px] md:block">
                    {menu.links.map((link) => {
                      if (link.label === 'Account') {
                        return (
                          <li key={link._key} className="md:mb-4">
                            <div className="inline-block rounded-8 bg-lighterGray p-4">
                              <Button
                                onClick={handleAccountClick}
                                className="px-8 py-[5px]"
                              >
                                {link.label}
                              </Button>
                            </div>
                          </li>
                        )
                      }

                      const url = getUrlFromLink(link)
                      return (
                        <li key={link._key} className="md:mb-4">
                          <div className="inline-block rounded-8 bg-lighterGray p-4">
                            <Button
                              href={url}
                              external={link.type === 'external'}
                              className="px-8 py-[5px]"
                            >
                              {link.label}
                            </Button>
                          </div>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              )
            })}
          </div>
          <div className="w-full pt-40 md:w-auto md:pt-0 lg:min-w-[600px]">
            <Newsletter />
          </div>
        </div>
        <div className="relative w-full items-end justify-between pt-[70px] uppercase md:flex md:pt-[100px] md:text-center">
          <Image src={logoUrl} alt="Chnge Logo" width={88} height={18} />
          <p className="pt-16 text-midGray md:pt-0">
            ©2023 CHNGE, Brooklyn, NYC. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  )
}
